import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { PreferencesService } from './services/preferences.service';
import { NotifierV2Service } from './services/notifier-v2.service';
import { ParentCommunicatorService } from './services/parent-communicator.service';
import { Subscription } from 'rxjs';
import { ParentMessageType } from './common/models/ParentMessage';
import { AuthenticationService } from './services/authentication.service';
import { EditorMode, NotifierEvents, StripeMessageActions, VippsPaymentStatus } from './common/enums/enums';
import { AppConstatnts } from './common/constants/app-contstants';
import { MessageDialogService } from './components/common/message-dialog/services/message-dialog.service';
import { LoadingService } from './services/UI/loading.service';
import { Title } from '@angular/platform-browser';
import { ProjectRefService } from './services/project-ref.service';
import { MembershipService } from './services/membership.service';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {

  initialPageLoadedSubscription: Subscription;
  navigateToPageSubscription: Subscription;
  routeChangeSubscription: Subscription;
  initialAuthenticationSubscription: Subscription;
  routeChangeAuthenticationSubscription: Subscription;
  isAuthenticated: boolean = false;
  isUnsupportedSettings: boolean = false;
  appDefaultCulture: string;
  paymentStatus:VippsPaymentStatus;
  isAuthorized: boolean = false;
  loadingState: boolean = false;

  private emblachatElement: HTMLIFrameElement | null = null;
  private emblachatScriptLoaded = false;
  
  constructor(public translate: TranslateService,
    private preferenceService: PreferencesService,
    private notifierService: NotifierV2Service,
    private parentCommunicatorService: ParentCommunicatorService,
    private authenticationService: AuthenticationService,
    private messageDialogService: MessageDialogService,
    private loadingService : LoadingService,
    private projectRefService : ProjectRefService,
    private router: Router,
    private changeDetector: ChangeDetectorRef, // for expression already changed issue
    private titleService: Title,
    private membershipService: MembershipService,
    private translateHandler: TranslateHandler,
    ) 
    {
      this.appDefaultCulture = environment.DEFAULT_CULTURE;
    }
  

  ngOnInit(): void {
      // if the encEmail there pass it                  
      // Cant get query param from app component is angular ..wtf
      //https://stackoverflow.com/questions/54316263/unable-to-read-querystring-parameters-from-app-component
      const params = new URLSearchParams(window.location.search);

    this.loadingService.getState().subscribe(state => {
      this.loadingState = state;
      // this.updateEmblachatVisibility();
    })
    this.loadApplication(params.get('encEmail'));

    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem('supportPopupData');
    });
  }

  closeEmblachatIfOpen() {
    // Check that we actually have an iframe
    if (!(this.emblachatElement instanceof HTMLIFrameElement)) return;

    const iframeDoc = this.emblachatElement.contentDocument;
    if (!iframeDoc) return;

    const toggleButton = iframeDoc.querySelector('.emb-chat-widget-toggler') as HTMLElement | null;
    const isChatOpen = iframeDoc.querySelector('.emb-show-chat-widget');

    if (isChatOpen && toggleButton) {
      toggleButton.click();
    }
  }

  private updateEmblachatVisibility() {
    if (this.loadingState) {
      // Hide the iframe if loading state is active
      this.closeEmblachatIfOpen();
    } else {
      // Make sure iframe is loaded and minimized by default
      this.loadEmblachat();
    }
  }

  private loadEmblachat() {
    if (this.emblachatElement) return;

    const iframe = document.createElement('iframe');
    iframe.classList.add('embla-chat-iframe');
    iframe.style.position = 'fixed';
    iframe.style.bottom = '10px';
    iframe.style.right = '10px';
    iframe.style.width = '60px';
    iframe.style.height = '60px';
    iframe.style.border = 'none';
    iframe.style.zIndex = '9999';
    iframe.style.display = 'block';

    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) {
      console.error('Could not get iframe document');
      return;
    }

    const chatGreeting = this.translateHandler.translate("ChatWidget.lbl_greeting");

    const style = `
    <style>
      .emb-chat-widget,
      .emb-chat-widget-toggler {
        position: fixed !important;
        right: 10px !important;
      }

      .emb-chat-widget {
        bottom: 70px !important;
      }

      .emb-chat-widget-toggler {
        bottom: 10px !important;
      }
    </style>
  `;

  // Write HTML content into iframe
  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
      ${style}
      </head>
      <body>
        <embla-chat
          accesskey="${environment.CHAT_WIDGET.accesskey}"
          primarycolor="#87B808"
          greeting="${chatGreeting}"
          header="Emly , FTbot"
          logourl="/assets/images/logo.png">
        </embla-chat>
        <script type="module" src="${environment.CHAT_WIDGET.scriptSrc}"></script>
      </body>
    </html>
  `;

    try {
      doc.open();
      doc.write(html);
      doc.close();
    } catch (error) {
      console.error('Error writing to iframe document', error);
    }

    this.emblachatElement = iframe;
    this.emblachatScriptLoaded = true;

    iframe.onload = () => {
      this.addToggleEventListener();  // Attach the event listener after the iframe has loaded
    };
  }

  private addToggleEventListener() {
    const iframe = this.emblachatElement as HTMLIFrameElement; // Cast to HTMLIFrameElement
    if (!iframe) return;

    const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDocument) return;

    const toggleButton = iframeDocument.querySelector('.emb-chat-widget-toggler');

    if (toggleButton) {

      toggleButton.addEventListener('click', () => {
        this.toggleEmblachat(); // Call the toggle method when the user clicks the toggle button
      });
    } else {
      console.error("Toggle button not found inside the iframe.");
    }
  }


  private toggleEmblachat() {
    if (this.emblachatElement) {
      const iframe = this.emblachatElement;
      // Check if iframe is minimized (small size) and toggle it
      if (iframe.style.width === '60px' && iframe.style.height === '60px') {
        iframe.style.width = '500px';   // Expanded size
        iframe.style.height = '630px';  // Expanded size
      } else {
        iframe.style.width = '60px';   // Minimized size
        iframe.style.height = '60px';  // Minimized size
      }
    }
  }

   // for expression already changed issue
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  /**
   * Do application startup checks and start/init app
   * https://indepth.dev/posts/1287/rxjs-heads-up-topromise-is-being-deprecated
   * @param response 
   * @returns 
   */
  private async loadApplication(encEmail: string) {
    this.translate.addLangs(['en', 'nb', 'no']);
    await this.translate.use(this.appDefaultCulture).toPromise();
    this.titleService.setTitle(this.translate.instant("application.title"))
    await this.authenticationService.init();
    // this.checkPaymentStatus();
    await this.membershipService.init();

    if (encEmail && !this.authenticationService.isAuthenticated1(encEmail)) {
      this.authenticationService.removeCookieToken();
      const authUrl = `${environment.FT_AUTH_URL}/authenticate/email?encEmail=${btoa(encEmail)}`;
      console.log(window.location.href);
      return window.open(authUrl, "_top");
  }
    else {
      if (!this.authenticationService.getCookieToken()) {
        this.messageDialogService.openError(
          this.translate.instant("Authentication.lbl_error"),
          this.translate.instant("Authentication.lbl_error_heading"),
          this.translate.instant("Authentication.lbl_error_login_again")
        ).toPromise();
        const embblaAuth_URL = environment.FT_AUTH_URL;
        window.open(environment.FT_PRODUCT_PAGE_URL, "_top");
        return;
      }
    }

    const webShopUrl = environment.WEB_SHOP_MEMBERSHIP_URL.replace("{0}", this.authenticationService.getUser().CustomerId);
    if (this.membershipService.getMembershipExpirationObj().isNewUser) {
      // await this.messageDialogService.openError(
      //   this.translate.instant("membership_check_error.lbl_title"),
      //   this.translate.instant("membership_check_error.lbl_info"),
      //   this.translate.instant("membership_check_error.lbl_prompt"))
      //   .toPromise();
        const emblaNoUrl = environment.FT_PRODUCT_PAGE_URL;
      window.open(emblaNoUrl, "_top");
      return;
    }

    if (!this.membershipService.getMembershipExpirationObj()) {
      await this.messageDialogService.openError(
        this.translate.instant("membership_check_error.lbl_title"),
        this.translate.instant("membership_check_error.lbl_info"),
        this.translate.instant("membership_check_error.lbl_prompt"))
        .toPromise();
      this.authenticationService.setCookieShop(true);
      window.open(webShopUrl, "_top");
      return;
    }

    if (this.membershipService.isMembershipExpired()) { 
      this.membershipService.startExpirationWatch();

      await this.messageDialogService.openError(
        this.translate.instant("expired_message.lbl_title"),
        this.translate.instant("expired_message.lbl_info"),
        this.translate.instant("expired_message.lbl_prompt"))
        .toPromise();
      this.authenticationService.setCookieShop(true);
      window.open(webShopUrl, "_top");
      return;
    }

    // Check if browser supported
    if (!this.getCurrentBrowser().includes("chrome")) {
      const res = await this.messageDialogService.openUnSupportedBrowserWarning().toPromise();
      if (res == StripeMessageActions.Download) {
        window.open(environment.CHROME_DOWNLOAD_URL, "_top");
        return;
      }
    }

    this.router.navigate(["dashboard"]);
    /** --------------------------------- Project list loading and create new ------------------------------------ */
    // TODO: Project load related : Move to different method
    // Load all project - First time
    var data = await this.projectRefService.load().catch(() => {
      const res = this.messageDialogService.openError("Error", "Project load error", "The project list is not loaded, Contact support").subscribe(() => {
        return;
      });
    });

    // TODO: Need to set this - no idea where this is connected
    this.isAuthenticated = true;
    this.projectRefService.setCurrentProject(this.projectRefService.getCurrentProject()?.familyProjectId);
  }

  // Get current browser
  private getCurrentBrowser() {
    const browsers = [
      ['opera', 'OPR'],
      ['ie', 'Trident'],
      ['edge', 'Edg'],
      ['brave', 'Brave'],
      ['safari', 'Safari'],
      ['chrome', 'Chrome'],
      ['firefox', 'Firefox']
    ];

    for (const [browser, agent] of browsers) {
      if (navigator.userAgent.includes(agent)) {

        // Need to add this due to user agent contains both chrome and safari
        // Need to handle
        if (agent == "Chrome" || agent == "Safari") {
          if (window.navigator.userAgent.toLowerCase().indexOf('chrome') > -1
            && window.navigator.vendor == "Google Inc.") {
            return 'chrome';
          }
          else {
            return 'safari';
          }
        } else {
          return browser;
        }
      }
    }
    return null
  }
  

  setInitialLoad(response: any, appDefaultCulture: any) {    
    this.preferenceService.load();
    //this.isAuthenticated = true;
    this.preferenceService.setCulture(appDefaultCulture);
    this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, this.mapRouteMember(response));
    this.parentCommunicatorService.send(ParentMessageType.ApplicationStarted, true);
    this.notifierService.setCurrentEditor(AppConstatnts.routerModes[response.routeInfo], this.mapRouteData(response), null);
  }

  setRouteChange(response: any) {
    this.notifierService.setCurrentEditor(AppConstatnts.routerModes[response.routeInfo], this.mapRouteData(response), null);
  }

  mapRouteMember(member: any = null) {
    if (member != null && member !== undefined) {
      return {
        Id: member.rootMember?.Id,
        DisplayName: member.rootMember?.DisplayName,
        FirstName: member.FirstName,
        LastName: member.LastName
      };
    }
  }

  mapRouteData(response) {
    if (response != null && response !== undefined) {
      return {
        id: response.rootMember?.Id,
        editorMode: response === 'TreeEditor'? EditorMode.TreeEditor: -1
      }
    }
    return null;
  }

  ngOnDestroy(): void {
    if (this.initialPageLoadedSubscription) {
      this.initialPageLoadedSubscription.unsubscribe();
    }
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe();
    }
    window.removeEventListener('beforeunload', () => {
    sessionStorage.removeItem('supportPopupData');
  });
  }

  checkPaymentStatus(): void {
        this.authenticationService.isPaymentInProgress(this.authenticationService.getUser().CustomerId).subscribe(isAuthorized => {
        this.isAuthorized = isAuthorized;
      });
    }

}